/* WAVEMAG theme script — vanilla JS, no dependencies */
(function () {
  'use strict';

  var W = window.WAVEMAG || { routes: {}, strings: {}, cartType: 'drawer' };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function toast(message) {
    var el = $('[data-toast]');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    clearTimeout(el._t);
    el._t = setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () { el.hidden = true; }, 300);
    }, 2600);
  }

  /* ---------- Drawers ---------- */
  var activeDrawer = null;
  var lastFocus = null;

  function openDrawer(id) {
    var drawer = document.getElementById(id);
    if (!drawer) return false;
    if (activeDrawer && activeDrawer !== drawer) closeDrawer(activeDrawer, true);
    lastFocus = document.activeElement;
    drawer.hidden = false;
    // force reflow so the transition runs
    void drawer.offsetWidth;
    drawer.classList.add('is-open');
    document.body.classList.add('no-scroll');
    $$('[aria-controls="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    activeDrawer = drawer;
    var panel = $('.drawer__panel', drawer);
    var target = $('input[type="search"]', panel) || $(FOCUSABLE, panel);
    setTimeout(function () { if (target) target.focus(); }, 60);
    return true;
  }

  function closeDrawer(drawer, keepFocus) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
    $$('[aria-controls="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    setTimeout(function () { if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, 450);
    if (activeDrawer === drawer) activeDrawer = null;
    if (!keepFocus && lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      var id = opener.getAttribute('data-drawer-open');
      if (id === 'CartDrawer' && W.cartType !== 'drawer') return;
      if (openDrawer(id)) e.preventDefault();
      return;
    }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      e.preventDefault();
      closeDrawer(closer.closest('.drawer'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (activeDrawer) closeDrawer(activeDrawer);
      var facets = $('.facets.is-open');
      if (facets) toggleFacets(false);
      $$('details[data-nav-dropdown][open]').forEach(function (d) { d.removeAttribute('open'); });
    }
    if (e.key === 'Tab' && activeDrawer) {
      var nodes = $$(FOCUSABLE, $('.drawer__panel', activeDrawer)).filter(function (n) { return n.offsetParent !== null; });
      if (!nodes.length) return;
      var first = nodes[0], last = nodes[nodes.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- Header ---------- */
  function initHeader() {
    var header = $('[data-header]');
    if (header) {
      var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
    var dropdowns = $$('details[data-nav-dropdown]');
    dropdowns.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) dropdowns.forEach(function (o) { if (o !== d) o.removeAttribute('open'); });
      });
      d.addEventListener('mouseenter', function () { if (window.matchMedia('(hover: hover)').matches) d.setAttribute('open', ''); });
      d.addEventListener('mouseleave', function () { if (window.matchMedia('(hover: hover)').matches) d.removeAttribute('open'); });
    });
    document.addEventListener('click', function (e) {
      dropdowns.forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
    });
  }

  /* ---------- Announcement rotator ---------- */
  function initRotators(scope) {
    $$('[data-rotator]', scope).forEach(function (r) {
      if (r.hasAttribute('data-rotator-ready')) return;
      r.setAttribute('data-rotator-ready', '');
      var slides = $$('.announcement__slide', r);
      if (slides.length < 2) return;
      var i = 0;
      var interval = parseInt(r.getAttribute('data-interval'), 10) || 5000;
      var timer = setInterval(next, interval);
      function next() {
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }
      r.addEventListener('mouseenter', function () { clearInterval(timer); });
      r.addEventListener('mouseleave', function () { timer = setInterval(next, interval); });
    });
  }

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-minus], [data-qty-plus]');
    if (!btn) return;
    var wrap = btn.closest('[data-qty]');
    var input = $('input', wrap);
    var min = input.min !== '' ? parseInt(input.min, 10) : 0;
    var max = input.max !== '' ? parseInt(input.max, 10) : Infinity;
    var val = parseInt(input.value, 10) || 0;
    val = btn.hasAttribute('data-qty-plus') ? Math.min(max, val + 1) : Math.max(min, val - 1);
    if (String(val) === input.value) return;
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart (Shopify AJAX API + Section Rendering API) ---------- */
  function cartSectionIds() {
    var ids = ['cart-drawer'];
    var page = $('[data-cart-page]');
    if (page) ids.push(page.getAttribute('data-section-id'));
    return ids;
  }

  function parseHTML(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function renderCartSections(sections) {
    if (!sections) return;
    var drawerHTML = sections['cart-drawer'];
    if (drawerHTML) {
      var doc = parseHTML(drawerHTML);
      var fresh = $('[data-cart-contents]', doc);
      var current = $('[data-cart-contents]');
      if (fresh && current) current.replaceWith(fresh);
      if (fresh) updateCount(parseInt(fresh.getAttribute('data-cart-count-value'), 10) || 0);
    }
    var page = $('[data-cart-page]');
    if (page) {
      var id = page.getAttribute('data-section-id');
      if (sections[id]) {
        var pdoc = parseHTML(sections[id]);
        var freshInner = $('[data-cart-page-inner]', pdoc);
        var curInner = $('[data-cart-page-inner]', page);
        if (freshInner && curInner) curInner.replaceWith(freshInner);
      }
    }
  }

  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
      el.classList.remove('is-bump');
      void el.offsetWidth;
      el.classList.add('is-bump');
    });
  }

  function addToCart(form) {
    var fd = new FormData(form);
    fd.append('sections', cartSectionIds().join(','));
    fd.append('sections_url', window.location.pathname);
    return fetch(W.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || data.status) throw new Error(data.description || data.message || W.strings.error);
        return data;
      });
    });
  }

  function changeLine(line, quantity) {
    return fetch(W.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: cartSectionIds(), sections_url: window.location.pathname })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || data.status) throw new Error(data.description || data.message || W.strings.error);
        return data;
      });
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form || W.cartType !== 'drawer' || !window.fetch) return;
    e.preventDefault();
    var btn = $('[data-add-button]', form);
    var errorEl = $('[data-form-error]', form) || (form.closest('[data-product]') && $('[data-form-error]', form.closest('[data-product]')));
    if (errorEl) errorEl.hidden = true;
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
    addToCart(form).then(function (data) {
      renderCartSections(data.sections);
      openDrawer('CartDrawer');
    }).catch(function (err) {
      if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
      else toast(err.message);
    }).then(function () {
      if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
    });
  });

  var lineTimers = {};
  function pendingLine(input) {
    var key = input.getAttribute('data-line-input');
    clearTimeout(lineTimers[key]);
    lineTimers[key] = setTimeout(function () { updateLine(input); }, 350);
  }

  function updateLine(input) {
    var line = parseInt(input.getAttribute('data-line-input'), 10);
    var qty = Math.max(0, parseInt(input.value, 10) || 0);
    var row = input.closest('.cart-item');
    if (row) row.classList.add('is-updating');
    changeLine(line, qty).then(function (data) {
      renderCartSections(data.sections);
    }).catch(function (err) {
      if (row) row.classList.remove('is-updating');
      toast(err.message);
    });
  }

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-input]');
    if (input) { pendingLine(input); return; }
    var note = e.target.closest('[data-cart-note]');
    if (note) {
      fetch(W.routes.cart + '/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ note: note.value })
      });
    }
  });

  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-line-remove]');
    if (!remove || !window.fetch) return;
    e.preventDefault();
    var row = remove.closest('.cart-item');
    if (row) row.classList.add('is-updating');
    changeLine(parseInt(remove.getAttribute('data-line-remove'), 10), 0).then(function (data) {
      renderCartSections(data.sections);
    }).catch(function (err) {
      if (row) row.classList.remove('is-updating');
      toast(err.message);
    });
  });

  /* ---------- Product page ---------- */
  function initProduct(root) {
    var picker = $('[data-variant-picker]', root);
    var mediaList = $('[data-media-list]', root);
    var counter = $('[data-media-current]', root);

    if (mediaList && counter) {
      mediaList.addEventListener('scroll', debounce(function () {
        var idx = Math.round(mediaList.scrollLeft / mediaList.clientWidth);
        counter.textContent = idx + 1;
      }, 60), { passive: true });
    }

    if (!picker) return;
    var json = $('[data-variants-json]', picker);
    var variants = json ? JSON.parse(json.textContent) : [];
    var url = root.getAttribute('data-product-url');
    var sectionId = root.getAttribute('data-section-id');
    var idInput = $('[data-variant-id]', root);

    function selectedOptions() {
      return $$('[data-option-group]', picker).map(function (g) {
        var checked = $('input:checked', g);
        var select = $('select', g);
        return checked ? checked.value : (select ? select.value : null);
      });
    }

    function markAvailability(selected) {
      $$('[data-option-group]', picker).forEach(function (group, gi) {
        $$('input[data-option]', group).forEach(function (input) {
          var candidate = selected.slice();
          candidate[gi] = input.value;
          var match = variants.find(function (v) { return v.options.every(function (o, i) { return o === candidate[i]; }); });
          var label = input.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    }

    function setButton(text, disabled) {
      var btn = $('[data-add-button]', root);
      if (!btn) return;
      btn.disabled = disabled;
      var label = $('[data-add-text]', btn);
      if (label) label.textContent = text;
    }

    function onChange() {
      var selected = selectedOptions();
      $$('[data-option-group]', picker).forEach(function (g, i) {
        var lbl = $('[data-option-selected]', g);
        if (lbl) lbl.textContent = selected[i];
      });
      markAvailability(selected);
      var variant = variants.find(function (v) { return v.options.every(function (o, i) { return o === selected[i]; }); });
      if (!variant) { setButton(W.strings.unavailable, true); return; }

      if (idInput) {
        idInput.value = variant.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      setButton(variant.available ? W.strings.addToCart : W.strings.soldOut, !variant.available);
      if (window.history.replaceState) window.history.replaceState({}, '', url + '?variant=' + variant.id);

      if (variant.featured_media && mediaList) {
        var item = $('[data-media-id="' + variant.featured_media.id + '"]', mediaList);
        if (item) {
          $$('.product__media-item', mediaList).forEach(function (m) { m.classList.remove('is-active'); });
          item.classList.add('is-active');
          if (window.matchMedia('(min-width: 990px)').matches) {
            mediaList.insertBefore(item, mediaList.firstElementChild);
          } else {
            mediaList.scrollTo({ left: item.offsetLeft - mediaList.offsetLeft, behavior: 'smooth' });
          }
        }
      }

      if (W.preview) return;
      var requestedId = variant.id;
      fetch(url + '?variant=' + variant.id + '&section_id=' + sectionId)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (!idInput || String(idInput.value) !== String(requestedId)) return;
          var doc = parseHTML(html);
          $$('[data-swap]', root).forEach(function (el) {
            var key = el.getAttribute('data-swap');
            var fresh = $('[data-swap="' + key + '"]', doc);
            if (fresh) el.innerHTML = fresh.innerHTML;
          });
        })
        .catch(function () {});
    }

    picker.addEventListener('change', function (e) {
      if (e.target.closest('[data-option]')) onChange();
    });
    markAvailability(selectedOptions());
  }

  /* ---------- Product recommendations ---------- */
  function initRecommendations() {
    $$('[data-recommendations]').forEach(function (el) {
      if (el.children.length) return;
      var url = el.getAttribute('data-url');
      if (!url) return;
      var load = function () {
        fetch(url).then(function (r) { return r.text(); }).then(function (html) {
          var fresh = $('[data-recommendations]', parseHTML(html));
          if (fresh && fresh.innerHTML.trim()) {
            el.innerHTML = fresh.innerHTML;
            initReveal(el);
          }
        });
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) { io.disconnect(); load(); }
        }, { rootMargin: '0px 0px 400px 0px' });
        io.observe(el);
      } else { load(); }
    });
  }

  /* ---------- Collection facets ---------- */
  function toggleFacets(force) {
    var facets = $('.facets');
    if (!facets) return;
    var open = typeof force === 'boolean' ? force : !facets.classList.contains('is-open');
    facets.classList.toggle('is-open', open);
    document.body.classList.toggle('no-scroll', open);
    $$('[data-facets-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', String(open)); });
    if (open) { var f = $('#FacetsPanel ' + 'summary'); if (f) f.focus(); }
  }

  function initFacets() {
    var form = $('[data-facets-form]');
    if (!form) return;
    var submit = debounce(function () {
      var params = new URLSearchParams(new FormData(form));
      var clean = new URLSearchParams();
      params.forEach(function (v, k) { if (v !== '') clean.append(k, v); });
      window.location.href = form.getAttribute('action') + '?' + clean.toString();
    }, 500);
    form.addEventListener('change', function (e) {
      if (e.target.closest('[data-facet-input]')) {
        var mobileOpen = form.classList.contains('is-open');
        if (!mobileOpen || e.target.name === 'sort_by') submit();
      }
    });
    form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-facets-toggle]')) toggleFacets();
    });
  }

  /* ---------- Misc ---------- */
  document.addEventListener('change', function (e) {
    var el = e.target.closest('[data-autosubmit]');
    if (el && el.form) el.form.submit();
  });

  document.addEventListener('click', function (e) {
    var share = e.target.closest('[data-share]');
    if (!share) return;
    var data = { title: share.getAttribute('data-share-title'), url: share.getAttribute('data-share-url') };
    if (navigator.share) { navigator.share(data).catch(function () {}); }
    else if (navigator.clipboard) { navigator.clipboard.writeText(data.url).then(function () { toast(data.url); }); }
  });

  function initReveal(scope) {
    var items = $$('[data-reveal]:not(.is-visible)', scope);
    if (!document.body.classList.contains('has-reveal') || !('IntersectionObserver' in window)) {
      items.forEach(function (i) { i.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    items.forEach(function (i) { io.observe(i); });
  }

  function init() {
    $$('.password__login').forEach(function (d) { if ($('.form-message--error', d)) d.open = true; });
    initHeader();
    initRotators();
    $$('[data-product]').forEach(initProduct);
    initRecommendations();
    initFacets();
    initReveal(document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target);
    $$('[data-product]', e.target).forEach(initProduct);
    initRotators(e.target);
    initRecommendations();
  });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.querySelector('#CartDrawer')) openDrawer('CartDrawer');
  });
})();
